import { Controller } from "@hotwired/stimulus"

// Controller pour le scroll vers les ancres avec offset
export default class extends Controller {

  // Action appelée par les liens de la navbar
  scrollTo(event) {
    const href = event.currentTarget.getAttribute('href')

    // Extraire l'ancre de l'URL
    const anchorMatch = href.match(/#(.+)$/)
    if (!anchorMatch) return // Pas d'ancre, laisser le navigateur gérer

    const anchor = anchorMatch[1]
    const targetElement = document.getElementById(anchor)

    // Si l'élément cible existe sur cette page, scroller vers lui
    if (targetElement) {
      event.preventDefault()

      const offset = 100
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
    // Sinon, laisser le navigateur naviguer vers l'URL (qui inclut l'ancre)
  }
}
